import { useSelector, useDispatch } from 'react-redux'
import RalPicker from './../RalPicker'
import {
  getTranslation,
  getBaseModel,
  getComponent,
  getOption,
  getCustomColorPrice,
  getColor
} from '../../utils/bike-schema'
import { t } from '../../utils/i18n'
import RalPickerUrban from './../RalPickerUrban'
import Modal from '../Modal'
import Popover from '../Popover'
import { customColorChosen } from '../../actions'
import { getChoice, getOrderStatement } from '../../utils/bike-config'

const OptionColorPopover = () => {
  const dispatch = useDispatch()
  const {
    currencyCode,
    bikeConfig,
    optionColor: { componentId, optionId },
    latestPickedRals,
    disclaimer
  } = useSelector((state) => state)

  const baseModel = getBaseModel(bikeConfig.baseModelId)
  const component = getComponent(baseModel, componentId)
  const option = getOption(component, optionId)
  const choice = getChoice(bikeConfig, componentId)
  const activeRal = choice && choice.color && choice.color.ral

  const { customColorCount } = getOrderStatement(bikeConfig)
  const customColorPrice = getCustomColorPrice(
    currencyCode,
    bikeConfig.baseModelId
  )
  const priceDiffForRal = (ral) => {
    const color = getColor(ral)
    const activeIsStandard = activeRal ? getColor(activeRal).standard : false
    if (customColorCount === 0 && !color.standard) {
      // If no custom color is chosen and this color is not standard, then show `+$xxx`
      return customColorPrice
    } else if (customColorCount === 1 && !activeIsStandard && color.standard) {
      // If exactly one custom color is chosen, this component is the one, and this color is standard, then show `-$xxx`
      return -customColorPrice
    } else {
      return 0
    }
  }
  const { choices } = bikeConfig

  if (disclaimer) {
    document.body.classList.remove('dimmed')

    return (
      <Popover
        className="velorbis-customizer-color-picker"
        width={'520px'}
        alignTo={`.velorbis-customizer-component[data-component="${component.id}"]`}
      >
        {baseModel.id.startsWith('urban') ? (
          <>
            <div className="velorbis-customizer-popover-header">
              {t('urban_color')}
            </div>
            <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-no-padding">
              <RalPickerUrban
                activeRal={activeRal}
                priceDiffForRal={priceDiffForRal}
                currencyCode={currencyCode}
                onSelect={(ral) =>
                  dispatch(customColorChosen(component.id, option.id, ral))
                }
                latestPickedRals={latestPickedRals}
                choices={choices}
                baseModelId={baseModel.id}
              />
            </div>
          </>
        ) : (
          <>
            <div className="velorbis-customizer-popover-header">
              {component.id === 'electric-motor'
                ? t('option_color_title', {
                    component: getTranslation(component.name)
                  })
                    .replace('Elektrisk motor og ', '')
                    .replace('Electric motor and ', '')
                : t('option_color_title', {
                    component: getTranslation(component.name)
                  })}
            </div>
            <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-no-padding">
              <RalPicker
                activeRal={activeRal}
                priceDiffForRal={priceDiffForRal}
                currencyCode={currencyCode}
                onSelect={(ral) =>
                  dispatch(customColorChosen(component.id, option.id, ral))
                }
                latestPickedRals={latestPickedRals}
                choices={choices}
              />
            </div>
          </>
        )}
      </Popover>
    )
  } else {
    document.body.classList.add('dimmed')
    return <Modal />
  }
}

export default OptionColorPopover
